import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import sendRequest from "./assets/sendRequest";
import aSubmitLegacy from "./assets/aSubmitLegacy";
import aSubmit from "./assets/aSubmit";

/**
 * VuwForm (extends VuwerComponent)
 * include async form
 * @options
 * - {Boolean} async
 * - {String} ACTION_URL
 * - {String} inputPartsClassName
 * - {String} inputIdPrefix
 * - {Object} config
 * - {Function} showLoading
 * - {Function} hideLoading
 * - {Function} ajaxErrorCallback
 * - {Object} fileUploaderCallbacks
 */
vuwer.appendKlass("VuwForm", {
	// [settable props]
	async: true,
	ACTION_URL: "",
	inputPartsClassName: "vuw-form-inp",
	inputIdPrefix: "",
	ajaxErrorCallback: function(methodName, xhr, textStatus, errorThrown) {},
	fileUploaderCallbacks: undefined,
	
	/**
	 * コンストラクタ
	 * @param {Object} [opt]
	 * @returns this | false
	 */
	_initialize: function _initialize(opt) {
		if( Klass("VuwForm").parent._initialize.call(this, opt) ) {
			u_.isObject(this.config) || (this.config = {});
			if( !u_.isNumber(this.config.ajaxTimeoutTime) ) {
				this.config.ajaxTimeoutTime = 5000;
			}
			
			// [unshift onReady callback]
			this._onReadyCallbacks.unshift(this._onReadyDefault);
			return this;
		} else {
			return false;
		}
	},
	
	/**
	 * DOM操作の準備完了コールバック
	 * @param {$object} $self
	 * @returns this
	 */
	_onReadyDefault: function onReady($self) {
		if($self.length) {
			$self.addClass("vuw-form");
			
			$self.find("input, select, textarea").each((i, elm) => {
				if( elm.type && ("hidden_submit_button").indexOf(elm.type) >= 0) {
					return true;
				}
				$(this).addClass(this.inputPartsClassName);
			});
			
			if(this.async) {
				$self
				// [submit to aSubmit]
				.on("submit.async", function(e, isTrigger) {
					if(!isTrigger) {
						e.preventDefault();
						$.data(this, "vuw").aSubmit();
					}
				})
				// [kill Enter submit]
				.on("keypress.killEnterSubmit", "input", e => {
					return (e.keyCode !== 13);
				});
				
			} else
			if(!$self.attr("action") && this.ACTION_URL) {
				$self.attr("action", this.ACTION_URL);
			}
			
			if(Klass("Console").device[0] === "sp") {
				// モバイルの場合、入力要素へのfocusでズームした画面をblurで戻す
				const $vp = $(document.head).children("meta[name='viewport']");
				const cntnt = $vp.attr("content");
				if(cntnt.indexOf("maximum-scale") < 0) {
					$self.on("blur", ".inp", e => {
						$vp.attr("content", cntnt + ",maximum-scale=1");
						setTimeout($.fn.attr.bind($vp, "content", cntnt), 100);
					});
				}
			}
		}
		
		return this;
	},
	
	/**
	 * 処理中の表示
	 * @param {String} [methodName]: 処理名
	 * @returns this
	 */
	showLoading: function showLoading(methodName) {
		!!this.$self && this.$self.attr("data-processing-by", methodName);
		return this;
	},
	
	/**
	 * 処理中の非表示
	 * @param {String} [methodName]: 処理名
	 * @returns this
	 */
	hideLoading: function hideLoading(methodName) {
		if(this.$self && this.$self.attr("data-processing-by") === methodName) {
			this.$self.attr("data-processing-by", null);
		}
		return this;
	},
	
	/**
	 * VuwFieldインスタンスの取得
	 * @param {String} [fieldType]
	 * @param {Boolean} [deep=false]: 深い階層まで探すかどうか
	 * @returns {Object}
	 */
	getField: function getField(fieldType, deep) {
		const obj = {};
		u_.isString(fieldType) || (fieldType = "");
		this.getChildren().forEach(vuw => {
			if( vuw instanceof Klass("VuwField") ) {
				if(!fieldType || vuw.vuwType === fieldType + "Field") {
					obj[vuw.paramKey] = vuw;
				}
				
				if(deep) {
					Object.assign( obj, Klass("VuwForm").prototype.getField.call(vuw, fieldType, deep) );
				}
			} else {
				Object.assign( obj, Klass("VuwForm").prototype.getField.call(vuw, fieldType, deep) );
			}
		});
		return obj;
	},
	
	/**
	 * valオブジェクトから取得すべき値のキーを判定
	 * @param {VuwField instance} vuwField
	 * @param {Object} val
	 * @returns {String}
	 */
	_getKeyOfValForField: function _getKeyOfValForField(vuwField, val) {
		let k;
		if( val.hasOwnProperty(vuwField.paramKey) ) {
			k = vuwField.paramKey;
		} else
		if(vuwField.inpType === "password") {
			k = "_" + vuwField.paramKey + "_length";
			if( !val.hasOwnProperty(k) ) {
				k = undefined;
			}
		}
		return k;
	},
	
	/**
	 * 入力部品に値を入力
	 * file, link項目が非同期実行になるためcallbackを引数に持つ
	 * @param {Object} val
	 * @param {Function} [callback]
	 * @returns this
	 */
	setVal: function setVal(val, callback) {
		if( !u_.isObject(val) ) {
			throw new TypeError("arguments[0] must be Object.");
		}
		
		const
			fieldMap = this.getField(),
			promiseList = [];
		
		Object.keys(fieldMap).forEach(pk => {
			const
				vuwField = fieldMap[pk],
				k = this._getKeyOfValForField(vuwField, val);
			
			promiseList.push( !!k ? vuwField.setVal(val[k]) : vuwField.clearVal() );
		});
		
		if( u_.isFunction(callback) ) {
			$.when.apply($, promiseList).then( callback.bind(this) );
		}
		
		return this;
	},
	
	/**
	 * 入力部品の値の取得
	 * @param {Stirng} paramKey
	 * @returns this
	 */
	getVal: function getVal(paramKey) {
		const val = {};
		u_.isString(paramKey) || (paramKey = "");
		this.getChildren().forEach(vuw => {
			if( vuw instanceof Klass("VuwField") ) {
				if(!paramKey || vuw.paramKey === paramKey) {
					const v = vuw.getVal();
					(v !== undefined) && (val[vuw.paramKey] = v);
				}
			} else {
				Object.assign( val, Klass("VuwForm").prototype.getVal.call(vuw, paramKey) );
			}
		});
		return val;
	},
	
	/**
	 * 入力部品の値の初期化
	 * @returns this
	 */
	clearVal: function clearVal() {
		u_.isFunction(this.setDataId) && this.setDataId();
		
		this.getChildren().forEach(vuw => {
			if( vuw instanceof Klass("VuwField") ) {
				vuw.clearVal();
			} else {
				Klass("VuwForm").prototype.clearVal.call(vuw);
			}
		});
		return this;
	},
	
	/**
	 * 入力チェック
	 * @returns {Object} error object
	 */
	validate: function validate() {
		const fieldMap = this.getField();
		const errObj = {
			count: 0,
			$elm: false
		};
		
		Object.keys(fieldMap).forEach(k => {
			if( !fieldMap[k].validate() ) {
				errObj.count++;
				if(errObj.$elm) {
					errObj.$elm.add( fieldMap[k].$self );
				} else {
					errObj.$elm = fieldMap[k].$self;
				}
			}
		});
		
		!!errObj.count && $(document.scrollingElement).animate({
			scrollTop: errObj.$elm.eq(0).offset().top - this.scrollBuffer
		}, "fast");
		
		return errObj;
	},
	
	scrollBuffer: 30,
	
	/**
	* ajaxリクエスト送信
	*/
	_sendRequest: sendRequest,
	
	/**
	* for LTE IE9
	* FormDataを使用できない古いブラウザ向けの送信関数
	*/
	_aSubmitLegacy: aSubmitLegacy,
	
	/**
	* async submit（汎用）
	*/
	aSubmit: aSubmit,
	
	/**
	* データのIDをセット（編集フォーム用）
	* @param {String} v: ID文字列
	*/
	setDataId: function setDataId(v) {
		( v && u_.isString(v) ) || (v = null);
		this._dataId = v;
		
		this.onReady(function($self) {
			!!$self && $self.attr("data-id", v);
		});
		
		return this;
	},
	
	/**
	* データのIDを取得
	*/
	getDataId: function() {
		return this._dataId || "";
	}
}, "VuwerComponent");
